/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@apollo/client';
import { find as _find } from 'lodash';
import { useState } from 'react';
import { usePrevious } from './usePrevious';
export const usePaginatedFetchItems = ({ spec, fetchQuery, dataProp, initialPageSize = 10, initialSort, skip, }) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(initialPageSize);
    const [orderBy, setOrderBy] = useState(initialSort?.orderBy ?? null);
    const [orderByDir, setOrderByDir] = useState(initialSort?.orderByDir ?? null);
    const variables = {
        spec: {
            pagination: { page, pageSize },
            orderBy,
            orderByDir,
            ...(spec || {}),
        },
    };
    const { data, loading, error, refetch } = useQuery(fetchQuery, {
        variables,
        skip,
    });
    const prev = usePrevious(data);
    const currentOrPrev = data ?? prev;
    const { items, total } = currentOrPrev
        ? currentOrPrev[dataProp]
        : { items: [], total: 0 };
    const find = (id) => _find(items, item => item.id === id);
    return {
        items,
        page,
        setPage,
        pageSize,
        setPageSize,
        numPages: pageSize > 0 ? Math.ceil(total / pageSize) : 0,
        orderBy,
        setOrderBy,
        orderByDir,
        setOrderByDir,
        total,
        loading,
        error,
        find,
        refetch,
    };
};
